import * as marietta from '../../..';
import { CONTROL_ACTIONMODE, ITEM_MODE_KEY } from '../../Constants';
import { SVGSprite } from '../../flash/display';
import { Stage } from '../../model';

/**
 * Drag items
 */
export default class DraggerMobile {
  dragFunc: Function;

  dragEndFunc: Function;

  viewObj: Element;

  x: number;

  y: number;

  transformMatrix: string;

  targetItem: marietta.webcad.item.MonicaObject;

  public spt: SVGSprite;

  private moveMouseEvent: MouseEvent;

  /**
   * コンストラクタ
   * */
  constructor(container, target: marietta.webcad.item.MonicaObject) {
    this.viewObj = document.querySelector('#lib_control_dragger svg > g').cloneNode(true) as HTMLElement;
    this.viewObj.setAttribute('id', 'itemcontroller_control_dragger');
    container.appendChild(this.viewObj);

    this.spt = new SVGSprite(this.viewObj);

    // アクション
    let ua = marietta.webcad.WebCADGlobal.userAgentManager;
    if (ua.isMobile || ua.isTablet) {
      this.viewObj.addEventListener('touchstart', this.onMouseDownMe, { passive: false });
    } else {
      this.viewObj.addEventListener('mousedown', this.onMouseDownMe);
    }
    ua = null;

    this.targetItem = target;
  }

  /**
   * マウスダウンされた
   * @param MouseEvent
   */
  onMouseDownMe = (e: MouseEvent & TouchEvent) => {
    let ua = marietta.webcad.WebCADGlobal.userAgentManager;
    if (ua.isMobile || ua.isTablet) {
      if ((<TouchEvent>e).touches.length > 1) {
        return;
      }
    }

    // 選択モードのときは、バブリングさせない
    if (marietta.webcad.WebCADGlobal.webcad2Dmanager.currentActionMode === CONTROL_ACTIONMODE.ACTIONMODE_SELECT_ITEM) {
      e.stopPropagation();
    }

    // ドラッグの開始
    e.preventDefault();
    if (ua.isMobile || ua.isTablet) {
      document.addEventListener('touchmove', this.onMouseMoveMe, { passive: false });
      document.addEventListener('touchend', this.onMouseUpMe, { passive: false });
    } else {
      document.addEventListener('mousemove', this.onMouseMoveMe);
      document.addEventListener('mouseup', this.onMouseUpMe);
    }

    // リスト非表示
    marietta.webcad.WebCADGlobal.overlapItemList.hideList();

    const scope: DraggerMobile = this;

    // comment k.kubonaka
    // mousemoveハンドラのタイミングで描画処理を行うとIEで極端にFPS低下するため
    // 実際の描画処理は、SpriteのEnterFrame(setTimeOut)ベースで行う
    this.spt.onEnterFrame = (): void => {
      if (scope.moveMouseEvent != null) {
        scope.dragFunc(scope.moveMouseEvent, scope);
      }
    };
    ua = null;
  };

  /**
   * マウスが移動した
   */
  onMouseMoveMe = (e: MouseEvent & TouchEvent) => {
    const self: DraggerMobile = this; // 現在の場所

    // pad スマホ用タッチ座標修正
    const ua = marietta.webcad.WebCADGlobal.userAgentManager;
    if (ua.isMobile || ua.isTablet) {
      if (e.touches.length >= 2) {
        // self.deleteMe();
        self.onMouseUpMe(e);
        return;
      }

      e.preventDefault();
      Stage.refreshStageMouse(<any>e);
    }

    self.moveMouseEvent = e;

    // StairMoveの開始時に測定線を非表示にする
    const targetId = marietta.webcad.WebCADGlobal.itemManager.currentItem.itemInfo.id;
    const targetKey = targetId.substring(0, 3);
    if (targetKey === ITEM_MODE_KEY.MODE_ROOM_KEY || targetKey === ITEM_MODE_KEY.MODE_STAIR_KEY) {
      marietta.webcad.WebCADGlobal.itemManager.hideMeasureLine();
    }
  };

  /**
   * マウスがUPされた
   */
  onMouseUpMe = (e: MouseEvent & TouchEvent) => {
    let ua = marietta.webcad.WebCADGlobal.userAgentManager;
    if (ua.isMobile || ua.isTablet) {
      if ((<TouchEvent>e).touches.length > 1) {
        return;
      }
    }

    e.preventDefault();
    this.spt.deleteEnterFrame();
    this.moveMouseEvent = null;

    if (ua.isMobile || ua.isTablet) {
      document.removeEventListener('touchmove', this.onMouseMoveMe);
      document.removeEventListener('touchend', this.onMouseUpMe);
    } else {
      document.removeEventListener('mousemove', this.onMouseMoveMe);
      document.removeEventListener('mouseup', this.onMouseUpMe);
    }
    ua = null;

    // 終了の処理
    this.dragEndFunc(e);
    marietta.webcad.WebCADGlobal.webcad2Dmanager.saveToHistory();
    // StairMoveの開始時に測定線を非表示にする
    const targetId = marietta.webcad.WebCADGlobal.itemManager.currentItem.itemInfo.id;
    const targetKey = targetId.substring(0, 3);
    marietta.webcad.WebCADGlobal.itemManager.showMeasureLine();
    if (targetKey === ITEM_MODE_KEY.MODE_ROOM_KEY || targetKey === ITEM_MODE_KEY.MODE_STAIR_KEY) {
      // ライン測定を更新する
      marietta.webcad.WebCADGlobal.updateMeasureLine();
    }
  };

  /**
   * 移動 XY
   */
  move(x, y) {
    this.x = x;
    this.y = y;
    this.updateTranslate();
  }

  /**
   * 移動X
   */
  moveX(x) {
    this.x = x;
    this.updateTranslate();
  }

  /**
   * 移動Y
   */
  moveY(y) {
    this.y = y;
    this.updateTranslate();
  }

  /**
   * Translateのアップデート
   */
  updateTranslate() {
    // レイヤーのスケールの分、割ってやる事で見た目のサイズを維持する
    const root: SVGSprite = marietta.webcad.WebCADGlobal.layerGroup.spt;
    const sc: number = 1.5 / root.scaleX;

    // 対象が建具の場合は位置を逆にする
    if (this.targetItem instanceof marietta.webcad.item.Fitting) {
      // x,yについては、位置補正で使用している固定値6.5/25に対してのみスケールを適用する
      this.transformMatrix = `matrix(${sc},0,0,${sc},${this.x},${this.y - 35 - 50 * sc})`;
    } else {
      // x,yについては、位置補正で使用している固定値6.5/25に対してのみスケールを適用する
      this.transformMatrix = `matrix(${sc},0,0,${sc},${this.x},${this.y - 35 + 35 * sc})`;
    }

    this.viewObj.setAttribute('transform', this.transformMatrix);
  }

  //--------------------------------
  // モバイル用移動軸対応
  originalPosition: marietta.core.Point;

  /**
   * 元位置の保持
   */
  saveOriginalPoisition() {
    this.originalPosition = new marietta.core.Point(this.x, this.y);
  }

  /**
   * アイコンの非表示
   */
  hide() {
    (<HTMLElement> this.viewObj).style.visibility = 'hidden';
  }

  /**
   * アイコンの表示
   */
  show() {
    (<HTMLElement> this.viewObj).style.visibility = 'visible';
  }
}
